import styled from "styled-components";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import React, { useRef } from "react";
import { portfolioItems } from "../data";
import Portfolio from "./Portfolio";
import { useNavigate } from "react-router-dom";

const Portfolios = () => {
  const navigate = useNavigate();
  const ref = useRef();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end end", "start start"],
  });

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 10,
    damping: 30,
  });

  return (
    <div id="portfolios">
      {portfolioItems.map((item) => (
        <PortfolioWrapper ref={ref} key={item.id}>
          <div className="progress" id="portfoliosSection">
            <h2>{item.service}</h2>
            <ProgressBar style={{ scaleX }} />
          </div>

          <PortfolioContainer>
            <Portfolio productId={item.id} item={item} />
          </PortfolioContainer>

          {/* <ButtonWrapper>
          <Button>Explore Now</Button>
        </ButtonWrapper> */}
        </PortfolioWrapper>
      ))}
    </div>
  );
};

const PortfolioWrapper = styled.div`
  background-color: #f5fbfd;
  position: relative;
  .progress {
    position: sticky;
    top: 0;
    left: 0;
    padding-top: 50px;
    text-align: center;
    font-size: 32px;

    @media (max-width: 768px) {
      font-size: 20px;
      top: 5%;
    }

    .progressBar {
      height: 10px;
      background-color: white;
    }
  }
`;

const ProgressBar = styled(motion.div)`
  height: 10px;
  background-color: black;
`;

const PortfolioContainer = styled(motion.div)``;

const ButtonWrapper = styled.div`
  width: "100%";
  justify-content: center;
  display: flex;
  position: sticky;
  bottom: 20px;
  @media (max-width: 768px) {
    bottom: 15%;
  }
`;

const Button = styled.button`
  padding: 5px 50px;
  font-size: 14px;
  cursor: pointer;
  @media (max-width: 768px) {
    padding: 5px 40px;
  }
`;

export default Portfolios;
